export const environment = {
  name: "PROD",
  version: '2.17.35',
  showBanner: false,
  /* LOCAL  */
  apiUrl: "https://flowdy2-be.map-hosting.it/api/v1/",
  //apiUrl: 'https://be-prod-ilsea523oq-ew.a.run.app/api/private/',
  //apiUrl: "https://be-test-native-jh6el3v2ta-ew.a.run.app/api/v1/",
  //apiUrl: "https://be-test-jh6el3v2ta-ew.a.run.app/api/v1/",
  auth0: {
    clientId: "m8imYeELwGYRkBmnRjHVLMHYobMWdP0r",
    domain: "tim-documentale.eu.auth0.com",
    // audience: "https://tim-documentale.eu.auth0.com/api/v2/",
    audience: "https://tim-documentale-backend.map-hosting.it",
    redirectUri: window.location.origin,
  },
  /*  auth0Token: {
    url: "https://tim-documentale.eu.auth0.com/oauth/token",
    client_id: "m8imYeELwGYRkBmnRjHVLMHYobMWdP0r",
    client_secret: "sbcEQngnCUi24BT7opcbkxeA-_zGAqTeLxqafXzFJr2Gi1Co1-JIN1bZcMeZz_QP",
    audience: "https://tim-documentale.eu.auth0.com/api/v2/",
    grant_type: "client_credentials",
  }, */
  magazzino: {
    apiUrl: "https://flowdy2-magazzino-be.map-hosting.it/api/v1/magazzino/",
    auth_token: {
      header: "magazzino_client_key",
      value: "9OVpccq09jNdIkOwGu3!!_90BGssqPA5fN",
    },
    aziendaid_TIM: 2,
    movexpire_days: 4,
  },
  csvBox: {
    secret: "MCb0OnXiotviEw094rk6P0O1wzDtz0",
    secret_bando1: "Tsmz4kgwpRbQjw5bZnjBslSWrHzsB8",
    secret_centrali: "9M1sglLEHkuKxSh8OssckPUmS0VxgD",
    secret_aggiornaPratiche: "qloxvD8gTLvKYNTXvRDA7gY0xqJVBS",
    secret_aggiornaPraticheBando1: "QncN6nGFyPm4zUMdQp6uS27UveodXj",
    secret_importaPraticheSanita: "nAcpGBxCKILQR6mvj93hYNhRRUx9YV",
    secret_aggiornaPraticheSanita: "bmlsQBksLD32R89v0N81mLyx7nl9Oh",
    secret_importaPianiTecniciSanita: "DilS6rFba44flZN2indXZuVH2ptqkg",
    secret_importaPraticheBando1Fase0: "6jbUJI8WCuxebixXxk1Ex26ogKYaF5",
    secret_importaPraticheBando2Fase0: "GySHLKBPRRGH7Y0KecmH49eVVm7QSq",
    secret_comunicaEsitiConsegnaFase1: "v9ByXhSC4NAtB8oSUVfaoLuR2v83ez",
    secret_comunicaEsitiConsegnaFase2: "jkermDFrxME8uFepaYeKmqpN1orMTX",
    secret_comunicaEsitiConsegnaFase3: "sUfHn9ZNpTEcMsXS5GLIrR6jCqH5sU",
    secret_importaVincolateBando1: "9eQqCs2ERsMq2bLpa0ib3Bzq5R4qHJ",
    secret_importaVincolateBando2: "MRPYpVRaxoHyQ3Rl5qJkgmSFP9Llpr",
    secret_contabile_bando1: "AkJP4pzYoSJ6HjKPDMImtamoSnFHtt",
    secret_contabile_bando2: "dADyTzEu2gnBLT0Y106jgKYTCgONkX",
    secret_comunicaInformazioniFase3: "N0jOsFvNewcaj5LOzSk5uR234U1eWO",
    secret_aggiornaPF: "XnrCoSWtNKrES7PArkt6PUPUSUwWIx",
    secret_checkPratiche: "mflzfYbNLPhLMUzNd274JXQcZ2X4lx",
    secret_importaEsitoControlloTIMSupport: "UB4pqB926sJxd4wo3N8sYPTw4Iw54g",
    secret_aggiornaSituazioneOF: "eozjytcisX0CS4kpBlYzTsuJPGIioM",
    user: "default123",
  },
  firebase: {
    apiKey: "AIzaSyAqwiHO3d67BtWhgh4mBQqmp0ozFCjCE58",
    authDomain: "tim-documentale.firebaseapp.com",
    projectId: "tim-documentale",
    storageBucket: "tim-documentale.appspot.com",
    messagingSenderId: "472321957740",
    appId: "1:472321957740:web:b8f66d31c2798e912d1d49",
    measurementId: "G-G78QZVDHN2",
    collection_stats: "stats_azienda",
    collection_pratiche_scuola: "pratiche-scuola",
    collection_pratiche_sanita: "pratiche-sanita",
    collection_piani_tecnici_sanita: "piani-tecnici-sanita",
    collection_pratiche: "pratiche-produzione",
    collection_oda: "oda-produzione",
    collection_bef: "pratiche-produzione",
    collection_import_log: "import-log",
    collection_prontofibra: "prontofibra-produzione",
  },
  storageBucket: "tim-documentale.appspot.com",
  nt9ViewerUrl:
    "https://nt9convergo-viewer.maphosting.it/viewer/index.php/TimScuole/",
  //nt9ViewerUrl: "https://viewer-nt9.map-hosting.it/viewer/index.php/TimScuole/",
};
